import { render, staticRenderFns } from "./ELStatus.vue?vue&type=template&id=32dc1cce&scoped=true"
import script from "./ELStatus.vue?vue&type=script&lang=js"
export * from "./ELStatus.vue?vue&type=script&lang=js"
import style0 from "./ELStatus.vue?vue&type=style&index=0&id=32dc1cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc1cce",
  null
  
)

export default component.exports